// eslint-disable-next-line import/prefer-default-export
export const getMainUrl = pathCurrentLocation => {
  const urlParams = pathCurrentLocation.split('/');
  const mainIndex = urlParams.indexOf('main');
  let mainUrl = '';
  for (let i = 0; i <= mainIndex; i += 1) {
    mainUrl += `${urlParams[i]}/`;
  }

  return mainUrl;
};
